import { getLogger } from '../../util/logger';
import routerPaths from './routerPaths';

const logger = getLogger('dataHelpers');

export function processLicenses(tenantIn) {
  if (!tenantIn) {
    return null;
  }

  const tenant = { ...tenantIn };
  tenant.hasHybrid = false;
  tenant.hasTeams = false;
  tenant.hasAqua = false;
  tenant.totalLicenses = 0;

  tenant.allLicenses = [];

  if (tenant.internalLicenses != null) {
    tenant.allLicenses = tenant.allLicenses.concat(tenant.internalLicenses);
  }

  if (tenant.externalLicenses != null) {
    tenant.allLicenses = tenant.allLicenses.concat(
      tenant.externalLicenses.licenses,
    );
  }

  tenant.allLicenses.forEach((license) => {
    if (license.productShortCode != null) {
      switch (license.productShortCode.toLowerCase()) {
        case 'aqua':
          tenant.hasAqua = true;
          break;
        case 'hybrid':
        case 'aqua-hybrid':
          tenant.hasHybrid = true;
          tenant.hasAqua = true;
          tenant.hasTeams = true;
          break;
        case 'aqua-teams':
          tenant.hasHybrid = true;
          tenant.hasTeams = true;
          break;
        default:
          logger.error(`Unexpected product code ${license.productShortCode}`);
      }
    }

    if (license.licenseQtyType != null) {
      switch (license.licenseQtyType.toLowerCase()) {
        case 'hybrid':
          tenant.hasHybrid = true;
          tenant.hasAqua = true;
          break;
        case 'cloud':
          tenant.hasAqua = true;
          break;
        case 'concurrent':
          tenant.hasHybrid = true;
          tenant.hasTeams = true;
          break;
        default:
          logger.error(
            `Unexpected license quantity type ${license.licenseQtyType}`,
          );
      }
    }

    const startDate = new Date(license.startDate);
    const expDate = new Date(license.endDate);
    const status = license.licenseStatus;
    let isActive = status.toLowerCase() === 'active';

    if (Date.now() - startDate < 0) {
      isActive = false;
    }
    if (expDate - Date.now() < 0) {
      isActive = false;
    }

    if (isActive) {
      tenant.totalLicenses += license.qty;
    }

    return license;
  });

  return tenant;
}

export function parseErrorMessage(error, setErrorMsg, routerHistory) {
  logger.error(error);
  let errorMsg = error.message ? error.message : error;
  if (error.body) {
    if (error.body.description) {
      errorMsg = error.body.description;
      if (error.body.data) {
        errorMsg += `: ${error.body.data}`;
      }
    } else if (error.body.errorMsg) {
      errorMsg = error.body.errorMsg;
    }
  }

  if (!errorMsg) {
    if (error.name || error.message) {
      errorMsg = `${error.name} ${error.message}`;
    } else {
      errorMsg = 'Unknown error';
    }
  }
  logger.error(errorMsg);

  if (error?.body?.redirect) {
    routerHistory.push({
      pathname: routerPaths.ERROR,
      state: {
        error: { name: error?.name, description: error?.body?.description },
      },
    });
  }

  setErrorMsg(errorMsg);
}

export function isEmbargoedCountry(countryCode) {
  return ['cu', 'ir', 'kp', 'sy'].includes(countryCode?.toLowerCase());
}

export function countryRequiresComplianceCheck(countryCode) {
  return ['by', 'cn', 'iq', 'hk', 'ru', 'sd', 'ss', 'ua', 've'].includes(
    countryCode?.toLowerCase(),
  );
}
